export const categories = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20pair%20of%20cream%20white%20minimal%20sneakers%20on%20a%20warm%20beige%20linen%20fabric%20background%2C%20soft%20natural%20lighting%20from%20left%20side%2C%20clean%20aesthetic%20product%20photography%20with%20organic%20shadows%2C%20simple%20neutral%20composition%20highlighting%20the%20footwear%20silhouette%2C%20editorial%20fashion%20still%20life%20with%20warm%20undertones%20and%20airy%20atmosphere&width=200&height=200&seq=cat-img-shoes-v3-01&orientation=squarish",
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Soft%20cream%20colored%20oversized%20hoodie%20folded%20neatly%20on%20a%20warm%20sand%20tone%20linen%20surface%2C%20gentle%20morning%20light%20casting%20subtle%20shadows%2C%20minimalist%20fashion%20product%20photography%20with%20neutral%20palette%2C%20clean%20uncluttered%20composition%2C%20elegant%20textile%20texture%20visible%2C%20warm%20beige%20and%20ivory%20tones&width=200&height=200&seq=cat-img-hoodies-v3-02&orientation=squarish",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Crisp%20white%20cotton%20tshirt%20laid%20flat%20on%20a%20warm%20oatmeal%20linen%20background%2C%20soft%20diffused%20natural%20daylight%2C%20minimalist%20fashion%20product%20flat%20lay%2C%20clean%20simple%20composition%20with%20gentle%20fabric%20folds%2C%20neutral%20warm%20tones%2C%20editorial%20product%20photography%20style%20with%20subtle%20texture%20details&width=200&height=200&seq=cat-img-tshirts-v3-03&orientation=squarish",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-t-shirt-2-line",
    image: "https://readdy.ai/api/search-image?query=Stylish%20camel%20tan%20lightweight%20jacket%20draped%20over%20a%20warm%20cream%20colored%20surface%2C%20soft%20natural%20window%20light%20creating%20gentle%20shadows%2C%20minimalist%20fashion%20editorial%20still%20life%2C%20neutral%20earth%20tone%20palette%2C%20elegant%20texture%20details%20visible%20on%20the%20fabric%2C%20clean%20sophisticated%20composition&width=200&height=200&seq=cat-img-jackets-v3-04&orientation=squarish",
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-pantone-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20beige%20linen%20trousers%20neatly%20folded%20on%20a%20warm%20sand%20colored%20textile%20background%2C%20soft%20natural%20morning%20light%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20neutral%20composition%2C%20gentle%20fabric%20texture%20visible%2C%20warm%20creamy%20tones%20with%20subtle%20shadows&width=200&height=200&seq=cat-img-pants-v3-05&orientation=squarish",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-base-station-line",
    image: "https://readdy.ai/api/search-image?query=Stylish%20cream%20beige%20baseball%20cap%20placed%20on%20a%20warm%20oatmeal%20linen%20surface%2C%20soft%20natural%20diffused%20light%2C%20minimalist%20fashion%20accessory%20photography%2C%20clean%20simple%20composition%2C%20neutral%20warm%20tones%2C%20gentle%20shadows%2C%20elegant%20casual%20aesthetic&width=200&height=200&seq=cat-img-headwear-v3-06&orientation=squarish",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20coordinated%20matching%20clothing%20set%20in%20warm%20beige%20and%20ivory%20tones%20arranged%20on%20a%20cream%20linen%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20fashion%20flat%20lay%20photography%2C%20clean%20harmonious%20composition%2C%20neutral%20palette%2C%20gentle%20textile%20folds%20visible&width=200&height=200&seq=cat-img-sets-v3-07&orientation=squarish",
  },
  {
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-checkbox-blank-line",
    image: "https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20in%20warm%20cream%20tone%20folded%20neatly%20on%20a%20light%20sand%20colored%20linen%20background%2C%20gentle%20natural%20diffused%20light%2C%20minimalist%20intimate%20apparel%20photography%2C%20clean%20simple%20composition%2C%20neutral%20warm%20palette%2C%20elegant%20texture%20details%20subtle%20and%20refined&width=200&height=200&seq=cat-img-underwear-v3-08&orientation=squarish",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-football-line",
    image: "https://readdy.ai/api/search-image?query=Stylish%20athletic%20jersey%20in%20warm%20sand%20tone%20with%20subtle%20textured%20fabric%20laid%20flat%20on%20cream%20linen%20surface%2C%20soft%20natural%20morning%20light%2C%20minimalist%20sportswear%20product%20photography%2C%20clean%20elegant%20composition%2C%20neutral%20warm%20earth%20tones%2C%20gentle%20shadows&width=200&height=200&seq=cat-img-jersey-v3-09&orientation=squarish",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-glasses-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20accessories%20including%20a%20warm%20toned%20leather%20bracelet%20and%20simple%20necklace%20arranged%20on%20cream%20linen%20background%2C%20soft%20natural%20diffused%20light%2C%20editorial%20fashion%20still%20life%20photography%2C%20neutral%20warm%20palette%2C%20clean%20sophisticated%20composition&width=200&height=200&seq=cat-img-accessories-v3-10&orientation=squarish",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-handbag-line",
    image: "https://readdy.ai/api/search-image?query=Stylish%20minimalist%20tote%20bag%20in%20warm%20camel%20tan%20leather%20placed%20on%20a%20cream%20linen%20background%2C%20soft%20natural%20daylight%20from%20window%2C%20elegant%20fashion%20accessory%20photography%2C%20clean%20simple%20composition%2C%20neutral%20warm%20earth%20tones%2C%20subtle%20texture%20details%20on%20the%20leather&width=200&height=200&seq=cat-img-bags-v3-11&orientation=squarish",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-link",
    image: "https://readdy.ai/api/search-image?query=Elegant%20warm%20tan%20leather%20belt%20coiled%20gracefully%20on%20a%20cream%20linen%20surface%2C%20soft%20natural%20morning%20light%2C%20minimalist%20fashion%20accessory%20photography%2C%20clean%20sophisticated%20composition%2C%20neutral%20warm%20palette%2C%20subtle%20leather%20grain%20texture%20visible&width=200&height=200&seq=cat-img-belts-v3-12&orientation=squarish",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20perfume%20bottle%20with%20warm%20amber%20toned%20glass%20on%20a%20cream%20linen%20background%2C%20soft%20natural%20diffused%20light%2C%20editorial%20beauty%20product%20photography%2C%20clean%20sophisticated%20composition%2C%20neutral%20warm%20palette%2C%20subtle%20reflections%20on%20glass%20surface&width=200&height=200&seq=cat-img-perfumes-v3-13&orientation=squarish",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    image: "https://readdy.ai/api/search-image?query=Assorted%20stylish%20lifestyle%20accessories%20including%20a%20warm%20toned%20scarf%20and%20sunglasses%20arranged%20on%20cream%20linen%20background%2C%20soft%20natural%20light%2C%20editorial%20flat%20lay%20photography%2C%20clean%20harmonious%20composition%2C%20neutral%20warm%20earth%20tones%2C%20gentle%20shadows&width=200&height=200&seq=cat-img-otherstuff-v3-14&orientation=squarish",
  },
];

export const featuredCategories = [
  {
    name: "Shoes & Sneakers",
    description: "Browse the latest footwear collections",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    badge: null,
    imageSeq: "featured-shoes-01",
  },
  {
    name: "Hoodies & Sweaters",
    description: "Cozy styles for every season",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    badge: "Trending",
    imageSeq: "featured-hoodies-01",
  },
  {
    name: "T-Shirts",
    description: "Essential tees and graphic designs",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-shirt-line",
    badge: "New Drop",
    imageSeq: "featured-tshirts-01",
  },
];